import { render, staticRenderFns } from "./cardWorkMain.vue?vue&type=template&id=22e6e968&scoped=true&"
import script from "./cardWorkMain.vue?vue&type=script&lang=js&"
export * from "./cardWorkMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6e968",
  null
  
)

export default component.exports